module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Suset2-90e57297fcc6932849252cf425b595da.svg";